import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import { NotebookView } from "@/features/notebook";

export const Route = createFileRoute("/_authenticated/me/notebook")({
  component: NotebookPage,
});

/**
 * "You are not creating content, you are noticing impact." The Notebook is
 * where that habit lives after the trainers leave (SB-29).
 */
function NotebookPage() {
  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader
        eyebrow="My space"
        title="Notebook"
        description="What you noticed, and what to post about it. Yours alone."
      />
      <NotebookView />
    </div>
  );
}
